export default {
    data() {
        return {
            requiredClasses: ["font-weight-bolder", "text-danger"]
        };
    },
    computed: {
        yesNo() {
            return [
                {
                    text: this.$i18n.t("pages.forms.common.yes-no.yes"),
                    value: 1
                },
                {
                    text: this.$i18n.t("pages.forms.common.yes-no.no"),
                    value: 0
                }
            ];
        },
        highMedLow() {
            return [
                {
                    text: this.$i18n.t("pages.forms.common.high-med-low.high"),
                    value: 1
                },
                {
                    text: this.$i18n.t("pages.forms.common.high-med-low.med"),
                    value: 2
                },
                {
                    text: this.$i18n.t("pages.forms.common.high-med-low.low"),
                    value: 3
                }
            ];
        },
        PglOgl() {
            return [
                {
                    text: this.$i18n.t(
                        "pages.forms.sample.sample-id.prefix.options.pgl"
                    ),
                    value: "PGL"
                },
                {
                    text: this.$i18n.t(
                        "pages.forms.sample.sample-id.prefix.options.ogl"
                    ),
                    value: "OGL"
                }
            ];
        }
    }
};
